export const WrongParametersCode = 3